import themeGet from '@styled-system/theme-get';
import styled, { css } from 'styled-components';
import { borderRadius, compose, fontSize, space } from 'styled-system';
import { borderRadiusAttrs } from '../utils/attrs';
import { applySizes, applyVariations, colorScheme, getPaletteColor, getTextColorOn } from '../utils/utils';
const sizes = {
  small: css(["", " line-height:", ";min-height:20px;& > svg{width:12px;height:12px;}"], themeGet('textStyles.small'), themeGet('lineHeights.display')),
  medium: css(["", " line-height:", ";min-height:24px;& > svg{width:14px;height:14px;}"], themeGet('textStyles.display0'), themeGet('lineHeights.standard'))
};
const variations = {
  outline: css(["color:", ";border-color:", ";", ""], getPaletteColor('base'), props => getPaletteColor(props.borderColor, 'base')(props), props => props.bg ? `background-color: ${getPaletteColor(props.bg, 'base')(props)};` : ''),
  fill: css(["color:", ";background-color:", ";border-color:", ";"], getTextColorOn('base'), getPaletteColor('base'), getPaletteColor('base')),
  // todo: remove this copy of the fill variation in v4 as its name does not follow conventions
  solid: css(["color:", ";background-color:", ";border-color:", ";"], getTextColorOn('base'), getPaletteColor('base'), getPaletteColor('base'))
};
/**
 * @public
 */
export const Stamp = /*#__PURE__*/styled.div.attrs(borderRadiusAttrs).withConfig({
  displayName: "Stamp",
  componentId: "sc-16l1c5o-0"
})(["display:inline-flex;align-items:center;vertical-align:top;min-height:24px;text-transform:uppercase;letter-spacing:", ";border-radius:2px;border-width:1px;border-style:solid;color:", ";", ";", ";", " ", ""], themeGet('letterSpacings.caps'), getPaletteColor('base'), ({
  theme
}) => applySizes(sizes, undefined, theme.mediaQueries), applyVariations('Stamp', variations), colorScheme, props => compose(space, fontSize, borderRadius)(props));
Stamp.displayName = 'Stamp';
Stamp.defaultProps = {
  px: 1,
  py: 0,
  color: 'border.light',
  bg: 'background.light',
  borderColor: 'border.base',
  borderRadius: 'md',
  size: 'medium',
  variation: 'outline'
};